// i18n key registry for pair-flow errors + UI strings (per W2 §6.2 +
// AGENTS.md §3 #14 繁體中文-only rule).

export const PAIR_I18N = {
  // invite (generate)
  invite_generated: "邀請連結已建立, 分享給對方",
  invite_rate_limited: "兩次生成邀請至少間隔 60 秒",
  invite_max_active: "一組 Pair 最多 5 個有效邀請, 請先取消舊邀請",
  invite_failed: "產生邀請連結時發生錯誤, 請稍後再試",

  // accept
  accept_already_in_pair: "你已在 Pair 中, 請先解除舊配對",
  accept_already_accepted: "這個邀請已被接受",
  accept_cancelled: "邀請已被建立者取消",
  accept_expired: "邀請已過期",
  accept_unknown: "邀請碼無效",
  accept_own: "不能接受自己建立的邀請",
  accept_claim_race: "這個邀請已被其他人接受",
  accept_validation: "請輸入 6 位數字邀請碼",

  // pair read / patch / dissolve
  pair_required: "尚未建立 Pair",
  pair_not_in_pair: "你不在這個 Pair 中",
  // W39.70 — was 「30 天」, and it contradicted `DissolvePair.tsx`, which says 7 in
  // both its toast and its banner. W2 §4.4 and
  // `pairs.service.crud.dissolve_pair`'s own docstring both say the retention is
  // 7 days, so 30 was the wrong one.
  pair_dissolved: "Pair 已解除, 7 天內可恢復",
  pair_not_found: "找不到 Pair",

  // invite cancel + public read
  invite_cancel_forbidden: "只有建立者可以取消邀請",
  invite_cancel_success: "已取消邀請",
  invite_status_pending: "等待接受",
  invite_status_accepted: "已被接受",
  invite_status_cancelled: "已被取消",
  invite_status_expired: "已過期",

  // UI / actions
  button_generate: "建立邀請連結",
  button_share: "分享",
  button_copy_link: "複製連結",
  button_copy_code: "複製邀請碼",
  button_cancel_invite: "取消邀請",
  button_dissolve: "解除配對",
  button_cancel: "取消",
  button_confirm: "確認",
  button_join: "加入",
  button_invite_existing: "輸入邀請碼",
  button_invite_new: "產生邀請碼",
  label_partner_name: "情侶名稱",
  label_relationship_start: "交往紀念日",
  label_inviter: "邀請者",
  label_status: "邀請狀態",
  label_couple_name: "情侶名稱",
  label_couple_name_confirm: "輸入情侶名稱以確認解除",
  expiry_in: "剩餘",
  expiry_days: "天",
  expiry_hours: "小時",
  expiry_minutes: "分鐘",
} as const;

export type PairI18nKey = keyof typeof PAIR_I18N;

export function pairErrorMessage(code: string | undefined, serverMessage?: string): string {
  if (serverMessage && serverMessage.trim()) return serverMessage;
  if (!code) return PAIR_I18N.invite_failed;
  switch (code) {
    case "RATE_LIMITED":
      return PAIR_I18N.invite_rate_limited;
    case "PAIR_REQUIRED":
      return PAIR_I18N.pair_required;
    case "PAIR_NOT_IN_PAIR":
      return PAIR_I18N.pair_not_in_pair;
    case "PAIR_NOT_FOUND":
      return PAIR_I18N.pair_not_found;
    case "PAIR_DISSOLVED":
      return PAIR_I18N.pair_dissolved;
    case "ALREADY_IN_PAIR":
      return PAIR_I18N.accept_already_in_pair;
    case "INVITE_NOT_FOUND":
      return PAIR_I18N.accept_unknown;
    case "PAIR_INVITE_EXPIRED":
      return PAIR_I18N.accept_expired;
    case "PAIR_INVITE_CANCELLED":
      return PAIR_I18N.accept_cancelled;
    case "PAIR_INVITE_ALREADY_ACCEPTED":
      return PAIR_I18N.accept_already_accepted;
    case "PAIR_INVITE_OWN":
      return PAIR_I18N.accept_own;
    case "PAIR_INVITE_CLAIM_RACE":
      return PAIR_I18N.accept_claim_race;
    case "PAIR_INVITE_CANCEL_FORBIDDEN":
      return PAIR_I18N.invite_cancel_forbidden;
    case "VALIDATION_FAILED":
      return PAIR_I18N.accept_validation;
    default:
      return PAIR_I18N.invite_failed;
  }
}
